import { useMemo } from "react";
import { BrmDetailTable } from "brm/tables/BrmTables";
import {
  createColumnMappedNoEdit,
  createColumnBooleanNoEditMapped,
  createColumnNameDetails,
} from "brm/tables/services/column/columnFactory";
// Styles
import * as S from "brm/styles/details-table.styles";
import { LoadingSpinner, ErrorBanner } from "components/elements";
import { RoutePath } from "routes/route-paths";
import { SystemApi } from "features/brm";

interface IProducingActivityProps {
  selectedElement: {
    id: string;
  };
  tableTitle: string;
}

const ProducerTable = ({ selectedElement, tableTitle }: IProducingActivityProps) => {
  const columns = useMemo(
    () => [
      createColumnNameDetails(RoutePath.Node.replace(":id", "")),
      createColumnMappedNoEdit("category"),
      createColumnMappedNoEdit("structcat"),
      createColumnBooleanNoEditMapped("isInternal"),
    ],
    []
  );

  const { data: producerData, isError: isProducerError } = SystemApi.useExchangeProducer({
    exchangeId: selectedElement.id,
  });

  if (isProducerError) {
    return <ErrorBanner msg="Error while loading Producer" />;
  }

  if (producerData) {
    return (
      <S.DetailsContainer id="ProducerTable_detailsPanel">
        <BrmDetailTable
          data={producerData}
          columns={columns}
          customProps={{ id: "ProducerTable_detailsPanel" }}
          showRowSelect={false}
          tableTitle={tableTitle}
        />
      </S.DetailsContainer>
    );
  }

  return <LoadingSpinner />;
};

export default ProducerTable;
